import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import '@/assets/icon/iconfont.css'
import VueLodash from 'vue-lodash'
import echarts from 'echarts'
import '@/assets/styles/index.scss'
import '@/icons'
import '@/permission'
import SIdentify from '@/components/Login/identify'
import getCfg from '@/config/index'
const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional
Vue.use(SIdentify)
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.prototype.$getCfg = getCfg
Vue.config.productionTip = false
Vue.directive('anchor', {
  inserted: function(el, binding) {
    el.onclick = function() {
      document.documentElement.scrollTop = document.getElementById('#anchor-' + binding.value).offsetTop
    }
  }
})
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
